module.exports = __webpack_public_path__ + "img/oaFlowData173@3x.c1f43c98.png";